const selectPrivateLessons = state => state.privateLessons;

export const selectSelectedPrivateLesson = state =>
	selectPrivateLessons(state).selected;
